import * as React from "react";
import { Pill, PillSize, PillVariant } from "azure-devops-ui/Pill";
import { PillGroup } from "azure-devops-ui/PillGroup";
import { IColor } from "azure-devops-ui/Utilities/Color";

export default class CompactPill extends React.Component<{}> {
    public render() {
        return (
            <PillGroup className="flex-row">
                <Pill size={PillSize.compact}>C#</Pill>
                <Pill size={PillSize.compact} variant={PillVariant.outlined}>
                    TypeScript
                </Pill>
                <Pill
                    color={this.lightColor}
                    size={PillSize.compact}
                    variant={PillVariant.colored}
                    onClick={() => alert("MSSQL pill clicked!")}
                >
                    MSSQL
                </Pill>
            </PillGroup>
        );
    }

    private lightColor: IColor = {
        red: 252,
        green: 194,
        blue: 173
    };
}
